
import {Component, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {formatDateTime} from "@/auxillary/date-format";
import DataExchangeFileDto = MdbsCore.DataExchangeFileDto;

@Component({
  components: {},
  filters: {
    formatDateTime
  }
})
export default class DataExchangeTable extends Vue {
  @Prop({required: true, default: new Array<DataExchangeFileDto>()})
  items: Array<DataExchangeFileDto>;

  @Prop({required: false, default: true})
  disableDownload: boolean;

  loading: boolean = false;

  headers: any = [
    {
      text: 'Erstellungsdatum',
      value: 'fileCreationDate',
      sort: (d1: Date, d2: Date) => new Date(d1).getTime() > new Date(d2).getTime() ? 1 : -1
    },
    {text: 'Download', value: 'actions', sortable: false, width: "100px", align: "center"}
  ];
  options: any = {
    sortBy: ['fileCreationDate'],
    sortDesc: [true]
  };
  footerOptions: any = {
    'items-per-page-options': [7, 30, 90, -1]
  };

  downloadFile(item: DataExchangeFileDto) {
    this.$emit("downloadFile", item);
  }

  get isDownloadDisabled() {
    return this.disableDownload;
  }
}
